module.exports = __webpack_public_path__ + "static/media/avatars_male_19.5403e368.png";